// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2WGmz","header":"Messages_header__1CtMV"};